import _ from 'lodash';
import { HITLBase } from './HITLBase';
export class Conferences extends HITLBase {
    static getConferenceMembers(options) {
        const route = this.getBaseUrl(options);
        const params = _.pick(options, ['hitlSessionId', 'memberId']);
        return this.request({
            route,
            params,
        });
    }
    static addOrUpdateConferenceMember(options) {
        const route = this.getBaseUrl(options);
        const data = _.pick(options, [
            'hitlSessionId',
            'memberId',
            'identifier',
            'type',
            'status',
            'state',
            'disconnectedAt',
        ]);
        return this.request({
            method: 'POST',
            route,
            data,
        });
    }
    static cleanUpConference(options) {
        const route = this.getBaseUrl(options);
        const params = _.pick(options, ['hitlSessionId', 'memberId']);
        return this.request({
            method: 'DELETE',
            route,
            params,
        });
    }
}
Conferences.MODULE_URL = 'conferences';
//# sourceMappingURL=Conferences.js.map